import { useTranslation } from 'next-i18next';
import Clock from '../../common/Icons/Clock';
import History from '../../common/Icons/History';
import SkipTranslationWrapper from '../../common/SkipTranslationWrapper';

type Props = {
  title: string;
};

const CheckoutIn = ({ title }: Props) => {
  const { t } = useTranslation('hotel');
  const titleGrouped = title.split('\n');
  return (
    <div className="mt-10 sm:mt-20">
      <h3 className="app-section-title pb-4">{t('check_in_and_out.title')}</h3>
      <div className="flex rounded-md bg-white">
        <div className="mr-7 hidden sm:block sm:w-auto">
          <Clock size={48} />
        </div>
        <div className="flex pr-4 sm:hidden sm:w-auto">
          <History size={24} />
        </div>

        <div className="flex w-5/6 flex-col gap-[5px] rounded-md bg-white sm:w-auto sm:justify-center sm:p-0">
          {titleGrouped.map((x) => (
            <SkipTranslationWrapper tag="p" key={x} className="text-small">
              {x}
            </SkipTranslationWrapper>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CheckoutIn;
